'use strict';

import { documentReady } from "./Shared/DocumentReady";
import '../css/pages/provider-registration.scss';
import DonationAmountOther from "./DonationAmountOther/DonationAmountOther";
import PasswordCheck from "./PasswordCheck/PasswordCheck";

function validateHCaptcha() {
    const form = document.querySelector("form");
    if (!form) return;

    form.addEventListener("submit", (event) => {
        const responseField = form.querySelector('[name="h-captcha-response"]');
        let response = responseField ? responseField.value : '';
        if (!response && typeof hcaptcha !== "undefined") {
            response = hcaptcha.getResponse();
        }
        const errorBox = document.getElementById("captcha-error2");

        if (!response || response.length === 0) {
            event.preventDefault();
            event.stopPropagation();
            if (errorBox) {
                errorBox.style.display = "block";
            }
            return false;
        }

        if (errorBox) {
            errorBox.style.display = "none";
        }
    });
}

documentReady(() => {
    window.super();
    new DonationAmountOther();
    new PasswordCheck();
    validateHCaptcha();
});
